export const wsUrl = () => {
    const dev = "127.0.0.1:23456";
    if (process.env.NODE_ENV === "development") {
        return `ws://${dev}`
    }
    return `wss://${location.host}/wss`;
}
export const config =  {
    appName: "电子商务运营训练平台"
}
